var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckboxChecked = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8158_388)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21429 2.16367C2.62254 2.16367 2.14286 2.64334 2.14286 3.2351V11.8065C2.14286 12.3983 2.62254 12.878 3.21429 12.878H11.7857C12.3775 12.878 12.8571 12.3983 12.8571 11.8065V3.2351C12.8571 2.64333 12.3775 2.16367 11.7857 2.16367H3.21429ZM0 3.2351C0 1.45985 1.43909 0.020813 3.21429 0.020813H11.7857C13.5609 0.020813 15 1.45987 15 3.2351V11.8065C15 13.5818 13.5609 15.0208 11.7857 15.0208H3.21429C1.43909 15.0208 0 13.5818 0 11.8065V3.2351Z",
    fill: "#5849A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3495 4.37799C10.1358 4.38421 9.93293 4.47335 9.7838 4.62656C8.50038 5.91281 7.51124 6.99163 6.33524 8.19506L5.13982 7.18428C4.9731 7.04339 4.75726 6.97449 4.53977 6.9927C4.32228 7.01103 4.12096 7.11495 3.98009 7.28167C3.83923 7.44838 3.77036 7.66417 3.78863 7.88167C3.80689 8.09917 3.91081 8.30049 4.07753 8.44138L5.8598 9.94931C6.01741 10.0828 6.21947 10.1521 6.42582 10.1435C6.63216 10.1348 6.82769 10.0487 6.97352 9.90249C8.45238 8.42028 9.50381 7.23796 10.9495 5.78821C11.0675 5.67238 11.1479 5.52356 11.1802 5.36135C11.2124 5.19913 11.1949 5.03092 11.1302 4.87878C11.0654 4.72663 10.9563 4.59742 10.817 4.50817C10.6778 4.41903 10.5149 4.37328 10.3495 4.37799Z",
    fill: "#5849A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8158_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.020813)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckboxChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checkbox-checked.b9f8770f.svg";
export { ForwardRef as ReactComponent };